module.exports = __webpack_public_path__ + "static/media/400029_01.0a1f1e12.png";